(() => {
  const VIXI_HANDLES = new Set([
    'recuerdo-para-bautizo-personalizado',
    'portavela-de-madera-recuerdo-personalizado-para-eventos',
  ]);

  const currentHandle = () => {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  const translateBlue = (root = document) => {
    if (!VIXI_HANDLES.has(currentHandle())) return;
    root.querySelectorAll('*').forEach((element) => {
      for (const node of element.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Blue') {
          node.textContent = node.textContent.replace('Blue', 'Azul');
        }
      }
    });
  };

  const enforcePersonalizedMinimum = (root = document) => {
    if (!VIXI_HANDLES.has(currentHandle())) return;
    root.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach((input) => {
      input.min = '10';
      input.dataset.min = '10';
      if (!input.value || Number(input.value) < 10) input.value = '10';
    });
  };

  const refresh = () => {
    translateBlue();
    enforcePersonalizedMinimum();
  };

  refresh();
  new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
})();
